import React, { useState, useEffect } from 'react';
import { Modal, Button, Radio, DatePicker, Space, Checkbox } from 'antd-v5';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const LastContactedFilterModal = ({ open, onClose, value, onApply }) => {
  const [mode, setMode] = useState(null);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [negate, setNegate] = useState(false);

  useEffect(() => {
    if (open) {
      setMode(value?.mode || null);
      setFrom(value?.from ? dayjs(value.from) : null);
      setTo(value?.to ? dayjs(value.to) : null);
      setNegate(!!value?.negate);
    }
  }, [open, value]);

  const handleModeChange = e => {
    setMode(e.target.value);
  };

  const handleApply = () => {
    if (!mode) {
      onApply(null);
      onClose();
      return;
    }

    if (mode === 'never') {
      onApply({ mode: 'never' });
    } else if (mode === 'range') {
      const result = { mode: 'range' };
      if (from) result.from = from.format('YYYY-MM-DD');
      if (to) result.to = to.format('YYYY-MM-DD');
      if (negate) result.negate = true;
      onApply(result);
    }

    onClose();
  };

  const handleClear = () => {
    setMode(null);
    setFrom(null);
    setTo(null);
    setNegate(false);
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Last Contacted"
      footer={null}
      className="audience-filter-modal"
      width={480}
      centered
    >
      <div style={{ padding: '8px 0 16px' }}>
        <Radio.Group onChange={handleModeChange} value={mode} style={{ width: '100%' }}>
          <Space direction="vertical" style={{ width: '100%' }} size={12}>
            <Radio value="never">Never contacted</Radio>

            <div>
              <Radio value="range">Date range</Radio>
              {mode === 'range' && (
                <div style={{ marginLeft: 24 }}>
                  <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                    <DatePicker
                      value={from}
                      onChange={setFrom}
                      placeholder="From"
                      style={{ flex: 1 }}
                    />
                    <DatePicker
                      value={to}
                      onChange={setTo}
                      placeholder="To"
                      style={{ flex: 1 }}
                    />
                  </div>
                  <Checkbox
                    checked={negate}
                    onChange={e => setNegate(e.target.checked)}
                    style={{ marginTop: 8 }}
                  >
                    Match the opposite (NOT contacted in this range)
                  </Checkbox>
                </div>
              )}
            </div>
          </Space>
        </Radio.Group>
      </div>

      <div className="audience-filter-modal__footer">
        <Button type="link" onClick={handleClear} disabled={!mode}>
          Clear
        </Button>
        <div className="audience-filter-modal__footer-right">
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </div>
    </Modal>
  );
};

LastContactedFilterModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  value: PropTypes.shape({
    mode: PropTypes.oneOf(['never', 'range']),
    from: PropTypes.string,
    to: PropTypes.string,
    negate: PropTypes.bool,
  }),
  onApply: PropTypes.func.isRequired,
};

LastContactedFilterModal.defaultProps = {
  value: null,
};

export default LastContactedFilterModal;
